"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.animationBreakCompleteAction = exports.ANIMATION_BREAK_COMPLETE = void 0;
exports.ANIMATION_BREAK_COMPLETE = 'ANIMATION_BREAK_COMPLETE';
exports.animationBreakCompleteAction = { type: exports.ANIMATION_BREAK_COMPLETE };
